// Keep the existing key so game sessions continue across the tracking expansion.
const SESSION_KEY = "game-visit-session";
let fallbackSessionId: string | undefined;

export function visitSessionId(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    // Retain a session for this page when browser storage is unavailable.
    return (fallbackSessionId ??= crypto.randomUUID());
  }
}
